import React from 'react';
import { useIntl } from 'react-intl-next';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { blockMenuMessages } from '@atlaskit/editor-common/messages';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { TextSelection } from '@atlaskit/editor-prosemirror/state';
import { ToolbarDropdownItem } from '@atlaskit/editor-toolbar';
import TextParagraphIcon from '@atlaskit/icon-lab/core/text-paragraph';
import { NORMAL_TEXT } from './consts';
var ParagraphBlockMenuItem = function ParagraphBlockMenuItem(_ref) {
  var api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var currentBlockType = useSharedPluginStateSelector(api, 'blockType.currentBlockType');
  var bulletListActive = useSharedPluginStateSelector(api, 'list.bulletListActive');
  var orderedListActive = useSharedPluginStateSelector(api, 'list.orderedListActive');
  var selection = useSharedPluginStateSelector(api, 'selection.selection');
  var isTextSelection = selection instanceof TextSelection;
  var isParagraph = isTextSelection && currentBlockType && currentBlockType === NORMAL_TEXT && !bulletListActive && !orderedListActive;
  var handleClick = function handleClick(event) {
    if (!selection) {
      return;
    }
    if (!isParagraph) {
      var _api$blockMenu;
      var triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? INPUT_METHOD.KEYBOARD : INPUT_METHOD.MOUSE;
      var inputMethod = INPUT_METHOD.BLOCK_MENU;
      api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.formatNode("paragraph", {
        inputMethod: inputMethod,
        triggeredFrom: triggeredFrom
      }));
    }
  };
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    onClick: handleClick,
    isSelected: isParagraph,
    elemBefore: /*#__PURE__*/React.createElement(TextParagraphIcon, {
      label: ""
    })
  }, formatMessage(blockMenuMessages.paragraph));
};
export var createParagraphBlockMenuItem = function createParagraphBlockMenuItem(_ref2) {
  var api = _ref2.api;
  return function () {
    return /*#__PURE__*/React.createElement(ParagraphBlockMenuItem, {
      api: api
    });
  };
};